// This class implements logic for manipulating the html for our report view.
// The HTML was server side rendered and we're just adding some light UI manipulation.

import { setQueryParam } from '@app/utils/url-helpers'

const MAIN_TABLE_SELECTOR =
  '.report-table-container     > table[data-behaviour="report-table"]'

export default class ReportTable {
  constructor($dom) {
    this.$dom = $dom
  }

  expandRow(row) {
    row.removeAttr('data-collapsed')

    const currentDataLevel = row.data('level')
    let $item = row.next()

    while ($item.data('level') > currentDataLevel) {
      if ($item.attr('data-collapsed') === 'true') {
        const collapsedGroupLevel = $item.data('level')

        $item.show()
        $item = $item.next()

        // Skip showing all the items inside this collapsed subgroup
        while ($item.data('level') > collapsedGroupLevel) {
          $item = $item.next()
        }
      } else {
        $item.css({ display: 'table-row' }) // much faster than show() on Safari
        $item = $item.next()
      }
    }
  }

  collapseRow(row) {
    row.attr('data-collapsed', true)

    const currentDataLevel = row.data('level')
    let $item = row.next()

    while ($item.data('level') > currentDataLevel) {
      $item.css({ display: 'none' }) // much faster than hide() on Safari
      $item = $item.next()
    }
  }

  expandAll() {
    this._reportTableElements()
      .find('[data-behaviour~="report-group-expand"]')
      .removeAttr('data-collapsed')
      .end()
      .find('tr')
      .css({ display: 'table-row' })
    setQueryParam('expand_all', true)
    this._toggleCollapseAllButton(false)
  }

  collapseAll() {
    this._reportTableElements()
      .find('[data-behaviour~="report-group-expand"]')
      .attr('data-collapsed', true)
      .end()
      .find('tr:not(.level_0)')
      .css({ display: 'none' })
    setQueryParam('expand_all', undefined)
    this._toggleCollapseAllButton(true)
  }

  _reportTableElements() {
    return this.$dom.find(`${MAIN_TABLE_SELECTOR}`)
  }

  _toggleCollapseAllButton(collapsed) {
    this.$dom
      .find('[data-behaviour="report-table-collapse-all"]')
      .toggle(!collapsed)
    this.$dom
      .find('[data-behaviour="report-table-expand-all"]')
      .toggle(collapsed)

    this._updateXLSDownloadUrl()
  }

  _getCurrentLanguage() {
    return this.$dom.find(MAIN_TABLE_SELECTOR).attr('data-language')
  }

  _getReportId() {
    return this.$dom.find(MAIN_TABLE_SELECTOR).attr('data-report-template-id')
  }

  _updateXLSDownloadUrl() {
    const reportId = this._getReportId()
    const downloadUrl =
      Silverfin.Routes.xlsx_report_path(
        Silverfin.currentFirmId,
        Silverfin.currentCompanyId,
        reportId
      ) + window.location.search
    this.$dom
      .find("[data-behaviour='download-report-as-xlsx']")
      .attr('href', downloadUrl)
  }
}
